import { useFeatureFlags } from "@/configs/featureFlag";
import { useIsSamboKunUser } from "@/features/partner/hooks/useIsSamboKunUser";

/**
 * 「参謀くんへ連携」ボタン・メニュー項目を表示するかどうかを返す hook。
 *
 * 以下の両条件を満たす場合のみ `true` を返す:
 *  1. LaunchDarkly フラグ `sendToSamboKun` が有効（`true`）
 *  2. ログインユーザーが参謀くん SSO 連携済み（{@link useIsSamboKunUser} が `true`）
 *
 * 表示制御ロジックを複数コンポーネント（presenter / FeedGrid など 5 ヶ所）で重複させず、
 * この hook で一元管理することで、フラグ名変更や条件追加時の修正漏れを防ぐ。
 *
 * @returns 参謀くん連携ボタンを表示する場合 `true`
 */
export const useShowSendToSamboKun = (): boolean => {
  const { sendToSamboKun } = useFeatureFlags();
  const isSamboKunUser = useIsSamboKunUser();
  return sendToSamboKun === true && isSamboKunUser;
};
